import Service from '@/service/building'
export default {
    methods: {
        getVr() {
            const { building_id } = this.$route.query
            return Service.getImgs(building_id, 'layout', {
                subcategory: 'VR视频'
            }).then(data => {
                const detailParam = encodeURIComponent(`building_id=${building_id}`)
                const building = data.building
                data.items.forEach((item) => {
                    if (item.vr_url) {
                        item.vr_link = `/building/web_vr?building_id=${building_id}&link=${encodeURIComponent(item.vr_url)}&title=${building.name}&detailParam=${detailParam}&category_id=${item.id}`
                    }
                })
                return data
            })
        },
    }
}